/**
 * The Encuentro utilities (`text-en-label`, `rounded-en-md`, `shadow-en-card`,
 * `min-h-en-control`...) taught to tailwind-merge, so `cn()` resolves them like
 * Tailwind's own scale.
 *
 * Without this, tailwind-merge reads every unknown `text-*` as a color:
 * `cn('text-en-label text-en-ink')` drops the size and keeps the color, and a
 * caller's `rounded-en-full` never replaces the primitive's `rounded-en-md`
 * (both survive and CSS order decides).
 *
 * The names mirror the `@theme` block of `app/styles/encuentro.css`;
 * `tailwind-merge.test.ts` reads that file and fails if a token is added or
 * renamed without updating this list. Only `en-` values are added, so classic
 * class strings merge exactly as before.
 */
export const ENCUENTRO_TEXT_SIZES = [
  'en-display',
  'en-title',
  'en-heading',
  'en-subheading',
  'en-body',
  'en-body-strong',
  'en-label',
  'en-meta',
  'en-caption',
] as const

export const ENCUENTRO_RADII = ['en-sm', 'en-md', 'en-lg', 'en-full'] as const

export const ENCUENTRO_SHADOWS = ['en-card', 'en-overlay'] as const

export const ENCUENTRO_SIZES = [
  'en-control',
  'en-control-compact',
  'en-icon',
  'en-sidebar',
  'en-rail',
  'en-measure',
  'en-topbar',
  'en-tabbar',
] as const

export const ENCUENTRO_FONTS = ['en-sans'] as const

/** `extendTailwindMerge({ extend: { theme } })` input, used by `cn` in lib/utils.ts. */
export const ENCUENTRO_TW_MERGE_THEME = {
  text: [...ENCUENTRO_TEXT_SIZES],
  radius: [...ENCUENTRO_RADII],
  shadow: [...ENCUENTRO_SHADOWS],
  spacing: [...ENCUENTRO_SIZES],
  font: [...ENCUENTRO_FONTS],
}
